<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
    [ngClass]="{
        'form-container-icon': icon !== null,
        'form-container-ng-select': isSelect,
        'form-container-ng-select-locations': isSelectLocations,
        'form-container-ng-select-locations-rounded':
            isSelectLocations && roundedLocationsPanel,
        'form-container-datepicker': isDatepicker,
        'form-container-textarea': isTextarea,
        'input-group': buttonsAfter.length !== 0
    }"
    class="form-container form-floating form-keep-floating"
    [errors]="ngControl?.control?.errors"
    fe-form-control-feedback
>
    <input
        *ngIf="!isTextarea && !isSelect && !isDatepicker && !isRangeDate"
        [(ngModel)]="value"
        [type]="
            type === 'card' ? 'tel' : type === 'expirationDate' ? 'tel' : type
        "
        [ngClass]="getDynamiClass()"
        class="form-control"
        [attr.id]="id !== null ? id : undefined"
        [attr.tabindex]="tabIndex !== null ? tabIndex : undefined"
        [placeholder]="placeholder"
        [mask]="mask"
        [disabled]="disabled"
        (blur)="onBlur()"
        (input)="onInput($event)"
        [attr.min]="min"
        [attr.max]="max"
        [attr.autocomplete]="autocomplete"
        [attr.autocorrect]="autocorrect"
        [attr.maxlength]="maxlength"
        [attr.inputmode]="inputmode"
        [disabled]="disabled"
        [ngModelOptions]="ngModelOptions"
    />
    <textarea
        [autosize]="true"
        *ngIf="isTextarea"
        [(ngModel)]="value"
        class="form-control"
        [attr.id]="id !== null ? id : undefined"
        [attr.tabindex]="tabIndex !== null ? tabIndex : undefined"
        [placeholder]="placeholder"
        [mask]="mask"
        [disabled]="disabled"
        [ngClass]="getDynamicTextAreaClass()"
        (blur)="onBlur()"
        [attr.min]="min"
        [attr.maxlength]="maxlength"
        [attr.max]="max"
        [attr.autocomplete]="autocomplete"
        [attr.autocorrect]="autocorrect"
        [disabled]="disabled"
        [readonly]="readonly"
        [ngModelOptions]="ngModelOptions"
        [rows]="4"
    ></textarea>
    <input
        *ngIf="isDatepicker"
        readonly
        #inputDatepicker
        [(ngModel)]="value"
        [type]="'text'"
        [ngClass]="getDynamiClass() + ' ' + uniqClassFormControl"
        class="form-control"
        [attr.id]="id !== null ? id : undefined"
        [attr.tabindex]="tabIndex !== null ? tabIndex : undefined"
        [placeholder]="placeholder"
        [mask]="mask"
        (blur)="onBlurDatepicker()"
        (focus)="onFocusDatepicker()"
        (input)="onInputDatePicker($event)"
        (keydown.Tab)="onTabDatePicker()"
        [attr.min]="min"
        [attr.max]="max"
        [attr.autocomplete]="'off'"
        [attr.autocorrect]="autocorrect"
        [attr.maxlength]="maxlength"
        [attr.inputmode]="inputmode"
        [disabled]="disabled"
        [ngModelOptions]="ngModelOptions"
    />
    <input
        style="position: absolute; bottom: 0; left: 0; visibility: hidden"
        type="text"
        tabindex="-1"
        *ngIf="isDatepicker"
        class="input-container-datepicker w-100"
    />

    <div class="dp-hidden position-absolute" *ngIf="isRangeDate">
        <input
            name="datepicker"
            class="form-control hidden"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="displayMonths"
            [dayTemplate]="dayTemplate"
            outsideDays="hidden"
            [weekdays]="1"
            [markDisabled]="isDateDisabled"
            [minDate]="disableDates()"
            [navigation]="'arrows'"
            [startDate]="setDateRange === 'start' ? fromDate! : toDate!"
            (dateSelect)="datepicker.close()"
            tabindex="-1"
        />
        <ng-template #dayTemplate let-date let-focused="focused">
            <span
                class="custom-day"
                [class.start]="isStartDate(date)"
                [class.end]="isEndDate(date)"
                [class.range]="isRange(date)"
                [class.range-active]="isRangeActive()"
                [class.faded]="isHovered(date) || isInside(date)"
                (mouseenter)="onHover(date)"
                (mouseleave)="onHoverEnd()"
            >
                {{ date.day }}
            </span>
        </ng-template>
    </div>
    <input
        *ngIf="isRangeDate && setDateRange === 'start'"
        class="form-control"
        autocomplete="off"
        [type]="'text'"
        [ngClass]="getDynamiClass()"
        [value]="formatDisplayDate(fromDate)"
        (click)="onFromDateInputClick()"
        [disabled]="disabled"
        [readonly]="true"
    />
    <input
        *ngIf="isRangeDate && setDateRange === 'end'"
        class="form-control"
        autocomplete="off"
        [ngClass]="getDynamiClass()"
        [value]="formatDisplayDate(toDate)"
        (click)="onToDateInputClick()"
        [disabled]="disabled"
        [readonly]="true"
    />
    <ng-select
        [ngClass]="[
            getDynamiClass() + ' ' + uniqClassSelect,
            isSelectLocations ? 'fe-select-input-locations' : '',
            isSelectLocations && roundedLocationsPanel
                ? 'fe-select-input-locations-rounded'
                : '',
            selectType
        ]"
        #select
        class="fe-select-input"
        *ngIf="isSelect"
        [items]="items"
        bindLabel="name"
        bindValue="id"
        [dropdownPosition]="isSelectLocations ? 'bottom' : 'auto'"
        (search)="onSearch($event)"
        (add)="onAddSeach($event)"
        (focus)="onFocusSeach($event)"
        (blur)="onBlurSeach($event)"
        (remove)="onRemoveSeach()"
        [searchFn]="
            customSelectSearchFn === null
                ? undefined
                : customSelectSearchFn === false
                  ? customSearchFn
                  : customSelectSearchFn
        "
        [groupBy]="groupBy"
        [placeholder]="placeholder"
        [attr.id]="id !== null ? id : undefined"
        (blur)="onBlurSelect()"
        (change)="onChangeItem()"
        [(ngModel)]="value"
        [multiple]="selectType === 'typing'"
        [maxSelectedItems]="1"
        [minTermLength]="3"
        [deselectOnClick]="false"
        [notFoundText]="
            isSelectLocations
                ? textNotFound ||
                  ('fe_core_input_select_location_text-not-found' | translate)
                : ('fe_core_input_select_text-not-found' | translate)
        "
        [appendTo]="appendToSelect"
        [disabled]="disabled"
        [inputAttrs]="{ autocomplete: 'off' }"
    >
        <ng-template [ngIf]="isSelectLocations">
            <ng-template #locationRow let-item>
                <div
                    class="container-col-name"
                    [class.is-not-returnable]="item?.disabled"
                >
                    <span class="location-name">
                        {{ item?.name }}
                        <button
                            *ngIf="item?.disabled"
                            type="button"
                            class="btn-no-return-info"
                            [ngbTooltip]="
                                'fe_core_input_select_location_no-return_message'
                                    | translate
                            "
                            triggers="hover focus"
                            container="body"
                            [placement]="tooltipPlacement"
                            tooltipClass="tooltip-no-return"
                            [popperOptions]="tooltipPopperOptions"
                            (click)="$event.stopPropagation()"
                            [attr.aria-label]="
                                'fe_core_input_select_location_no-return_message'
                                    | translate
                            "
                        >
                            <svg
                                viewBox="0 0 16 16"
                                width="16"
                                height="16"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <circle cx="8" cy="8" r="8" fill="currentColor" />
                                <rect
                                    x="7.1"
                                    y="3.5"
                                    width="1.8"
                                    height="6"
                                    rx="0.9"
                                    fill="#ffffff"
                                />
                                <circle cx="8" cy="11.7" r="1.05" fill="#ffffff" />
                            </svg>
                        </button>
                    </span>
                    <span *ngIf="item?.disabled" class="location-no-return-note">
                        {{
                            'fe_core_input_select_location_no-return_note'
                                | translate
                        }}
                    </span>
                </div>
            </ng-template>
            <ng-template ng-header-tmp>
                <div class="locations-columns">
                    <div
                        *ngIf="getGroupItems('airport').length > 0"
                        class="locations-column"
                    >
                        <div class="col-group">
                            <img
                                [src]="'images/plane.svg' | cdn"
                                class="col-group-icon"
                                alt="branch type"
                            />
                            {{
                                'fe_core_input_select_location_label_airports'
                                    | translate
                            }}
                        </div>
                        <div class="locations-column-scroll-wrap">
                            <div
                                class="locations-column-scroll"
                                #airportScroll
                                (scroll)="
                                    onLocationsColumnScroll(
                                        airportScroll,
                                        'airport'
                                    )
                                "
                            >
                                <div
                                    *ngFor="
                                        let item of getGroupItems('airport')
                                    "
                                    class="col-name"
                                    (click)="selectLocationItem(item)"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            locationRow;
                                            context: { $implicit: item }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                            <div
                                class="locations-column-scrollbar"
                                *ngIf="scrollThumb.airport.scrollable"
                            >
                                <div
                                    class="locations-column-scrollbar-thumb"
                                    [style.height.%]="scrollThumb.airport.height"
                                    [style.top.%]="scrollThumb.airport.top"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="getGroupItems('city').length > 0"
                        class="locations-column"
                    >
                        <div class="col-group">
                            <img
                                [src]="'images/map.svg' | cdn"
                                class="col-group-icon"
                                alt="branch type"
                            />
                            {{
                                'fe_core_input_select_location_label_city'
                                    | translate
                            }}
                        </div>
                        <div class="locations-column-scroll-wrap">
                            <div
                                class="locations-column-scroll"
                                #cityScroll
                                (scroll)="
                                    onLocationsColumnScroll(cityScroll, 'city')
                                "
                            >
                                <div
                                    *ngFor="let item of getGroupItems('city')"
                                    class="col-name"
                                    (click)="selectLocationItem(item)"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            locationRow;
                                            context: { $implicit: item }
                                        "
                                    ></ng-container>
                                </div>
                            </div>
                            <div
                                class="locations-column-scrollbar"
                                *ngIf="scrollThumb.city.scrollable"
                            >
                                <div
                                    class="locations-column-scrollbar-thumb"
                                    [style.height.%]="scrollThumb.city.height"
                                    [style.top.%]="scrollThumb.city.top"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template
                ng-option-tmp
                let-item="item"
                let-index="index"
                let-search="searchTerm"
            >
                <div
                    [ngClass]="{
                        'ng-option-airport': item?.group === 'airport',
                        'ng-option-city': item?.group === 'city',
                        'is-first': item?.first === true
                    }"
                    class="container-fluid"
                >
                    <div *ngIf="item?.first === true" class="col-group">
                        <img
                            [src]="
                                item?.group === 'airport'
                                    ? ('images/plane.svg' | cdn)
                                    : ('images/map.svg' | cdn)
                            "
                            class="col-group-icon"
                            alt="branch type"
                        />
                        {{
                            item?.group === 'airport'
                                ? ('fe_core_input_select_location_label_airports'
                                  | translate)
                                : ('fe_core_input_select_location_label_city'
                                  | translate)
                        }}
                    </div>
                    <div class="col-name">
                        <ng-container
                            *ngTemplateOutlet="
                                locationRow;
                                context: { $implicit: item }
                            "
                        ></ng-container>
                    </div>
                </div>
            </ng-template>
        </ng-template>
    </ng-select>
    <label
        class="form-label text-truncate"
        *ngIf="label !== null"
        [attr.for]="id !== null ? id : undefined"
        >{{ label }}</label
    >
    <div *ngIf="buttonsAfter.length === 0" class="container-btns-after d-flex">
        <div
            *ngIf="loading"
            [ngClass]="{ select: isSelect }"
            class="container-spinner d-flex align-items-center"
        >
            <div class="spinner-border"></div>
        </div>
    </div>
    <div *ngIf="buttonsAfter.length > 0" class="container-btns-after d-flex">
        <div
            *ngIf="loading"
            class="container-spinner me-0 d-flex align-items-center"
        >
            <div class="spinner-border"></div>
        </div>
        <button
            *ngFor="let btns of buttonsAfter"
            class="btn btn-link btns-after d-none d-md-inline-block"
            type="button"
            tabindex="-1"
            (click)="onClickBtnsAfter(btns)"
        >
            <ng-template [ngIf]="btns.icon !== null">
                <img
                    class="btn-icon"
                    [src]="(btns.icon ?? '') | cdn"
                    alt="button icon"
                />&nbsp;&nbsp;
            </ng-template>
            {{ btns.text }}
        </button>
    </div>
    <img
        class="arrow-focus"
        [src]="'images/flecha_morada.svg' | cdn"
        alt="arrow focus"
    />
    <div
        *ngIf="(!(buttonsAfter.length > 0) && isSelect) || isDatepicker"
        class="container-arrow-select"
        (click)="onClickArrowSelect()"
    >
        <img
            class="arrow-select"
            [src]="'images/arrow_select.svg' | cdn"
            alt="arrow_select"
        />
    </div>
</div>
